module.exports = __webpack_public_path__ + "img/chrity_2.caef668d.png";